import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Group, GroupInput } from '../../entities/group/group';
import { GroupsService } from '../../services/groups/groups.service';
import { LoadingService } from '../../services/loading.service';
import { LocationService } from '../../services/location/location.service';
import { UsersService } from '../../services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-group-dialog',
  templateUrl: './group-dialog.component.html',
  styleUrls: ['./group-dialog.component.scss']
})
export class GroupDialogComponent
  implements EditDialogInstance {

    groupForm: FormGroup;
    group: Group;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public groupService: GroupsService,
    public loadingService: LoadingService,
    public locationService: LocationService
  ) {

    if (this.config.data) {
      this.group = this.config.data;
    }

    this.groupForm = new FormGroup({});
    this.groupForm.addControl('id', new FormControl());
    // add form controls
    this.groupForm.addControl('name', new FormControl(undefined,
      [
        Validators.required,
      ]
    ));
    this.groupForm.addControl('roles', new FormControl());

    if (this.group) {
      this.groupForm.patchValue(this.group);
    }

    this.groupForm.valueChanges.subscribe((value) => {
      console.log(value);
    });
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    let groupInput = new GroupInput(this.groupForm.value);
    if(this.group){
      this.groupService.updateGroup(groupInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.updateGroup?.id);
      });
    } else {
      this.groupService.createGroup(groupInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.createGroup?.id);
      });
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.groupForm;
  }
}
